export const BENCHMARK = 'benchmark';
export const PROGRESS = 'progress';
export const INSTRUCTIONS = 'instructions';
export const HOME_CONNECT = 'homeconnect';
export const DUAL_LANGUAGE = 'duallanguage';
export const STUDENT_SUMMARY = 'studentsummary';
export const DIBELS_SEVEN_STUDENT_SUMMARY = 'studentSummary';

export const SS_PROGRESS = 'progress';
export const SS_TRC_SUMMARY = 'trc_summary';
export const SS_BENCHMARK_HISTORY = 'benchmark_history';

export const APP_PATHS = {
    BENCHMARK,
    PROGRESS,
    INSTRUCTIONS,
    HOME_CONNECT,
    DUAL_LANGUAGE,
    STUDENT_SUMMARY,
};

export const STUDENT_SUMMARY_PATHS = {
    SS_BENCHMARK_HISTORY,
    SS_TRC_SUMMARY,
    SS_PROGRESS,
};

const TRC_BASE_URL = '/trc-api';
const VOCABO_BASE_URL = '/lanternvoc/v01';
const SPELLING_BASE_URL = '/lanternspelling/v01';
const OL_BASE_URL = '/ol-api';
const APPLICATION_JSON = 'application/json';
const APPLICATION_FORM_URLENCODED = 'application/x-www-form-urlencoded';
const CONTENT_TYPE_HEADER = 'Content-Type';

export const WGEN_HELP_URL = '/wgenhelp';
export const HELP_PARAMS = '/index.htm?rscsh=1&rhmapid=';
export const PDF_GENERATOR = '/pdf/react-pdf-generator';

export const MES_VERSION = 'v2';

export const SHARED_API_URL = (baseUrl = '', appRootUrl = '') => {
    const STUDENT_SUMMARY_URL = `${appRootUrl}/${STUDENT_SUMMARY}`;
    const PORTAL_URL = '/portal';
    return {
        BASE_URLS: {
            BASE_URL: baseUrl,
            APP_ROOT_URL: appRootUrl,
            MAS_TOKEN_URL: '/mobilelogin/mas_token',
            LOGIN_URL: `/mobilelogin/idp_identification`,
            LOGOUT_URL: '/mobilelogin/logout',
            LOCAL_DEVELOPMENT_LOGIN_URL: `/mobilelogin/internal_educator_login`,
            PORTAL_URL,
            ROOT_URL: '/',
            USER_PROFILE_URL: `${PORTAL_URL}/userprofile`,
            BENCHMARK_URL: `${appRootUrl}/${BENCHMARK}`,
            PROGRESS_URL: `${appRootUrl}/${PROGRESS}`,
            INSTRUCTIONS_URL: `${appRootUrl}/${INSTRUCTIONS}`,
            HOME_CONNECT_URL: `${appRootUrl}/${HOME_CONNECT}`,
            DUAL_LANGUAGE_URL: `${appRootUrl}/${DUAL_LANGUAGE}`,
            RESULTS_URL: `${baseUrl}/rest/classSummary`,
            STUDENT_RESULTS_URL: `${baseUrl}/rest/studentSummary`,
            PROBE_DETAILS_URL: `${baseUrl}/rest/probeDetail`,
            R3D_INTERPS_URL: `${baseUrl}/rest/interpretation`,
            INK_URL: `${baseUrl}/InkRenderer`,
        },
        SS_URL: {
            STUDENT_SUMMARY_URL,
            BENCHMARK_HISTORY: `${STUDENT_SUMMARY_URL}/${SS_BENCHMARK_HISTORY}`,
            TRC_SUMMARY: `${STUDENT_SUMMARY_URL}/${SS_TRC_SUMMARY}`,
            PROGRESS: `${STUDENT_SUMMARY_URL}/${SS_PROGRESS}`,
        },
    };
};

export const HTTP_METHODS = {
    GET: 'get',
    PATCH: 'patch',
    POST: 'post',
    DELETE: 'delete',
    PUT: 'put',
};

export const HTTP_RESPONSE_CODE = {
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_RESPONSE: 400,
    UNAUTHORIZED: 401,
    FORDIDDEN: 403,
    SERVER_ERROR: 500,
    GATEWAY_TIMEOUT: 504,
};

export const JSON_HEADERS = {
    Accept: APPLICATION_JSON,
    [CONTENT_TYPE_HEADER]: APPLICATION_JSON,
};

export const FORM_HEADERS = {
    Accept: APPLICATION_JSON,
    [CONTENT_TYPE_HEADER]: APPLICATION_FORM_URLENCODED,
};

export const SSO_AUTH_TOKEN = 'sso.auth_token';
export const BEARER = 'Bearer ';

export const PDF_HEADERS = {
    Accept: 'application/pdf',
    [CONTENT_TYPE_HEADER]: APPLICATION_JSON,
};

export const PDF_ENCODING_HEADERS = {
    'Content-Encoding': 'gzip',
};

export const PDF_RESPONSE_TYPE = 'arraybuffer';

export const URL = {
    TRC: {
        TRC_RESULTS: `${TRC_BASE_URL}/results/v1/result_groups`,
    },
    VOCABO: {
        VOCABO_RESULTS: `${VOCABO_BASE_URL}/results?`,
        VOCABO_INTERPS: `${VOCABO_BASE_URL}/interpretations`,
        VOCABO_FORMS: `${VOCABO_BASE_URL}/forms`,
        VOCABO_HELP_URL: `${WGEN_HELP_URL}/voc2${HELP_PARAMS}VOC_`,
    },
    SPELLING: {
        SPELLING_RESULTS: `${SPELLING_BASE_URL}/results?`,
        SPELLING_INTERPS: `${SPELLING_BASE_URL}/interpretations`,
        SPELLING_FORM: `${SPELLING_BASE_URL}/forms`,
        SPELLING_HELP_URL: `${WGEN_HELP_URL}/spell2${HELP_PARAMS}SP_`,
    },
    OL: {
        OL_RESULTS: `${OL_BASE_URL}/results/v1/results?`,
        OL_INTERPS: `${OL_BASE_URL}/content/v1/cutscores`,
        OL_FORM: `${OL_BASE_URL}/content/v1/forms`,
        OL_HELP_URL: `${WGEN_HELP_URL}/mol${HELP_PARAMS}`,
    },
    D8_TRANSLATOR_RESULTS_URL: '/dibels8-api/aggregate-results/v1/results?',
    INTERCOM_USER_HASH_URL: '/api/third-party-secrets/intercom/userHash',
    LECTURA_RESULTS_URL: '/lectura-translator-api/v1/results',
    STUDENT_SUMMARIES_PDF_URL: `${PDF_GENERATOR}/v1/pdfs/all-student-summaries`,
    ALL_PM_GRAPHS_PDF_URL: `${PDF_GENERATOR}/v1/pdfs/all-pm-graphs`,
    HOME_CONNECT_PDF_URL: `${PDF_GENERATOR}/v1/pdfs/home-connect`,
    TRO_CLASS_SUMMARY_PDF_URL: `${PDF_GENERATOR}/v1/pdfs/tro-class-summary`,
    DUAL_LANGUAGE_CLASS_SUMMARY_PDF_URL: `${PDF_GENERATOR}/v1/pdfs/dual-language-class-summary`,
    CLASS_SUMMARY_PDF_URL: `${PDF_GENERATOR}/v1/pdfs/class-summary`,
};

export const PARAM = {
    CLASSE: 'classe',
    DISTRICT: 'district',
    PERIODS: 'periods',
    PERIOD: 'period',
    SCHOOL: 'school',
    APPLICATION_SID: 'applicationSid',
    APPLICATION_NAME: 'applicationName',
    APPLICATION_CONFIG: 'applicationConfig',
    STUDENT_IDS: 'student_uids',
    STUDENT_UID: 'student_uid',
    STUDENT_ID: 'studentId',
    RESULT_ID: 'result_id',
    ETERNAL_STUDENT_SID: 'eternalStudentSid',
    MEASURE: 'measure',
    ASSESSMENT: 'assessment',
    RESULT_PROBE: 'resultProbe',
    GRADE_ID: 'gradeId',
    GRADE: 'grade',
    GRADE_LEVEL: 'grade_level',
    RESULT_GROUP: 'resultGroup',
    YEAR: 'year',
    SCHOOL_YEAR: 'school_year',
    FORM_ID: 'form_id',
    SKILL_NAME: 'skill_name',
    CREATE_DATE: 'create_date',
    DATA_SOURCE: 'data_source',
    DISTRICT_UID: 'dist_uid',
    INST_UID: 'inst_uid',
    STAFF_UID: 'staff_uid',
    CLASS_OR_GROUP_ID: 'class_or_group_id',
    STUDENT_TEMPORAL_ID: 'student_temporal_id',
    STUDENT_UIDS: 'student_uids',
    CORRECT_RESPONSES: 'correct_responses',
    INCORRECT_RESPONSES: 'incorrect_responses',
    FIELDS: 'fields',
    TOTAL_ITEMS: 'total_items',
    SEQUENCE: 'sequence',
    FORM_NUMBER: 'form_number',
    WITH_RESULTS: 'with_results',
    WITH_PERCENTILES: 'with_percentiles',
    WITH_STATUSES: 'with_statuses',
    WITH_BOOK_INFO: 'with_book_info',
    HC_ACTIVITIES_IDS: 'activityContentSids',
    LANGUAGE: 'language',
    MOST_OFFICIAL: 'most_official',
    PARAM_INK_UID: 'inkUid',
    PARAM_TARGET_WIDTH: 'targWidth',
    PARAM_TARGET_HEIGHT: 'targHeight',
    PARAM_MARKUP: 'markup',
    LIN_WIDTH: 'linWidth',
    GENERATING_RESULT_ONLINE: 'online',
    GENERATING_RESULT_BY_SCRIPT: 'results-script',
    GENERATING_RESULT_BY_ASSESSMENT_IMPORTER: 'assessment-importer',
    OBSERVATIONS: 'with_observations',
    INST_CONTEXT: 'inst_context',
    DYSLEXIA: 'with_dyslexia',
    WITH_ZOG: 'with_zog',
    GOAL_VALUE: 'goal_value',
    SECURE_ASSESSMENT: 'secure-assessment',
};

export const ASSESSMENT = {
    TRC: 'trc',
};
